var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHello(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "250.000000pt",
    height: "250.000000pt",
    viewBox: "0 0 250.000000 250.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "#FFFFFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,250.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1083 2493 l-23 -4 0 -586 0 -585 53 6 c28 3 114 11 189 17 l138 12 2 565 3 564 -23 9 c-23 9 -296 10 -339 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514 2261 c-136 -95 -305 -294 -384 -450 -143 -285 -171 -633 -73 -945 77 -247 265 -505 471 -645 l62 -42 0 1066 c0 586 -2 1065 -3 1065 -2 0 -35 -22 -73 -49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920 1246 l0 -1067 62 43 c80 56 220 194 286 283 57 76 149 255 180 350 41 123 52 207 52 394 0 193 -10 264 -56 400 -89 257 -281 507 -496 646 l-28 17 0 -1066z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235 881 l-170 -16 0 -430 0 -430 187 -3 188 -2 2 433 c2 239 2 441 0 450 -2 9 -11 16 -20 16 -9 -1 -93 -9 -187 -18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHello);
export default __webpack_public_path__ + "static/media/HELLO.119f7009452e79c4f8e3fbce7e8b1c74.svg";
export { ForwardRef as ReactComponent };